/* eslint-disable indent */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import {
  useDispatch,
  useSelector,
} from 'react-redux';
import * as React from 'react';
import {
  ListSubheader,
  Box,
  Icon,
  Grid,
  InputAdornment,
  TextField,
  Avatar,
  Divider,
  List,
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Tabs,
  Tab,
  FormControl,
  FormControlLabel,
  Switch,
  Alert,
  IconButton,
  Menu,
  MenuItem,
  CircularProgress,
} from '@mui/material';
import {
  Task,
  Event,
  CalendarToday,
  Star,
  AutoAwesome,
  MoreVert,
  VisibilityOff,
} from '@mui/icons-material';
import Search from '@mui/icons-material/Search';
import {
  blueGrey,
  primary,
} from '../../../../../../../../utils/brandColors';
import useDebounce from '../../../../../../../../utils/useDebounce';
import {
  getColorForItem,
  getIconForItem,
} from '../../../../../../../../utils/iconHelper';
import HorseIcon from '../../../../../../../CustomIcons/Horse';
import BarnIcon from '../../../../../../../CustomIcons/Barn';
import TaskOptionComponent from '../TaskOption';
import { getDayOfWeekFromNumber } from '../../../../../../../../utils/barnBoardHelper';
import Horse from '../../../../../../../Horse';
import { updateHorseSuggestion } from '../../../../../../../../redux/horse/actions';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const SelectEventTemplate = ({
  tagsFilter,
  includeBarnTasks,
  includeHorseTasks,
  includeCalendarEvents,
  onTaskSelect,
  onCalendarEventSelect,
  selectedSlot,
  tab,
  setTab,
}) => {
  const dispatch = useDispatch();

  const [groupedTaskTemplates, setGroupedTaskTemplates] = React.useState({})
  const [calendarEvents, setCalendarEvents] = React.useState([]);
  const [mostUsed, setMostUsed] = React.useState([]);
  const [search, setSearch] = React.useState('');
  const [groupByTags, setGroupByTags] = React.useState(!!global.window.localStorage.getItem('global_task_tag_grouping'))
  const [groupedSuggestions, setGroupedSuggestions] = React.useState(null)
  const [openSuggestionMenu, setOpenSuggestionMenu] = React.useState(false);
  const [openSuggestionMenuAnchorEl, setOpenSuggestionMenuAnchorEl] = React.useState(null);
  const [openSuggestionHorseMenu, setOpenSuggestionHorseMenu] = React.useState(false);
  const [openSuggestionHorseMenuAnchorEl, setOpenSuggestionHorseMenuAnchorEl] = React.useState(null);
  const [alertMessage, setAlertMessage] = React.useState(null)

  const schedules = useSelector((state) => state.board.schedules)
  const mappedHorseSuggestions = useSelector((state) => state.board.mappedHorseSuggestions)
  const selectedLocation = useSelector((state) => state.location.selectedLocation)
  const tagTypes = useSelector((state) => state.tagType.tagTypes)
  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const isFetchingHorseSuggestion = useSelector((state) => state.horse.isFetchingHorseSuggestion);

  const debouncedSearch = useDebounce(search, 250);

  React.useEffect(() => {
    setAlertMessage(null)
    setOpenSuggestionMenu(false)
    setOpenSuggestionMenuAnchorEl(null);
    setOpenSuggestionHorseMenu(false)
    setOpenSuggestionHorseMenuAnchorEl(null);
    if (selectedSlot && selectedSlot.selectedSuggestion) {
      const eventTemplatesMap = Object.assign({}, ...(allEventTemplates.map((i) => ({ [i.id]: i }))))

      if (selectedSlot && selectedSlot.selectedSuggestion && selectedSlot.selectedSuggestion.daySuggestion) {
        const suggestDayTrend = selectedSlot.selectedSuggestion.daySuggestion.suggestDayTrend
          && selectedSlot.selectedSuggestion.daySuggestion.suggestDayTrend.length > 0
          && selectedSlot.selectedSuggestion.daySuggestion.suggestDayTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
            .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);

        let suggestMonthlyTrend = selectedSlot.selectedSuggestion.daySuggestion.suggestMonthlyTrend
          && selectedSlot.selectedSuggestion.daySuggestion.suggestMonthlyTrend.length > 0
          && selectedSlot.selectedSuggestion.daySuggestion.suggestMonthlyTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
            .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)]);
        suggestMonthlyTrend = suggestMonthlyTrend && suggestMonthlyTrend
          .filter((t) => !suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))

        let suggestRecentTrend = selectedSlot.selectedSuggestion.daySuggestion.suggestRecentTrend
          && selectedSlot.selectedSuggestion.daySuggestion.suggestRecentTrend.length > 0
          && selectedSlot.selectedSuggestion.daySuggestion.suggestRecentTrend.filter((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
            .map((taskTypeId) => eventTemplatesMap[parseInt(taskTypeId, 10)])
        suggestRecentTrend = suggestRecentTrend && suggestRecentTrend
          .filter((t) => (!suggestDayTrend || !suggestDayTrend.find((tt) => tt.id === t.id))
            && (!suggestMonthlyTrend || !suggestMonthlyTrend.find((tt) => tt.id === t.id)))

        setGroupedSuggestions(
          selectedSlot && selectedSlot.selectedSuggestion && selectedSlot.selectedSuggestion.daySuggestion && {
            suggestDayTrend,
            suggestMonthlyTrend,
            suggestRecentTrend,
          },
        )
      } else {
        setGroupedSuggestions(null)
      }
    }

    setTab((selectedSlot && selectedSlot.calendarEventTab === true)
      ? 1
      : 0)
  }, [selectedSlot])

  React.useEffect(() => {
    // get the most used templates
    const mostUsedCheck = {};
    for (let i = 0; i < schedules.length; i += 1) {
      if (mostUsedCheck[schedules[i].eventTemplate.id]) {
        mostUsedCheck[schedules[i].eventTemplate.id] = {
          count: mostUsedCheck[schedules[i].eventTemplate.id].count + 1,
          eventTemplate: schedules[i].eventTemplate,
        }
      } else {
        mostUsedCheck[schedules[i].eventTemplate.id] = {
          count: 1,
          eventTemplate: schedules[i].eventTemplate,
        }
      }
    }
    if (includeHorseTasks) {
      setMostUsed(Object.keys(mostUsedCheck)
        .sort((a, b) => mostUsedCheck[b].count - mostUsedCheck[a].count).map((c) => mostUsedCheck[c].eventTemplate)
        .filter((et) => et && et.tags && !et.tags.find((t) => t.id === selectedBarn.barnMetadata.barnTaskTypeTagId))
        .slice(0, 5));
    } else {
      setMostUsed([])
    }
  }, [schedules])

  const groupTasksByTag = (filterList) => {
    const mappedGroup = {};
    for (let i = 0; i < filterList.length; i += 1) {
      if (!groupByTags) {
        const baseTag = filterList[i].tags
          .filter((t) => t.id === selectedBarn.barnMetadata.horseTaskTypeTagId || t.id === selectedBarn.barnMetadata.barnTaskTypeTagId)
        // template doesn't have additional tags, so put in base bucket for barn task or horse task
        if (mappedGroup[baseTag[0].id]) {
          mappedGroup[baseTag[0].id] = [...mappedGroup[baseTag[0].id], filterList[i]]
        } else {
          mappedGroup[baseTag[0].id] = [filterList[i]]
        }
      } else if (filterList[i].tags.length === 1) {
        // template doesn't have additional tags, so put in base bucket for barn task or horse task
        if (mappedGroup[filterList[i].tags[0].id]) {
          mappedGroup[filterList[i].tags[0].id] = [...mappedGroup[filterList[i].tags[0].id], filterList[i]]
        } else {
          mappedGroup[filterList[i].tags[0].id] = [filterList[i]]
        }
      } else {
        // Only add to groups that are not already added
        const filteredTags = filterList[i].tags
          .filter((t) => t.id !== selectedBarn.barnMetadata.horseTaskTypeTagId && t.id !== selectedBarn.barnMetadata.barnTaskTypeTagId
            && t.id !== selectedBarn.barnMetadata.eventTaskTypeTagId)
        for (let j = 0; j < filteredTags.length; j += 1) {
          if (mappedGroup[filteredTags[j].id]) {
            mappedGroup[filteredTags[j].id] = [...mappedGroup[filteredTags[j].id], filterList[i]]
          } else {
            mappedGroup[filteredTags[j].id] = [filterList[i]]
          }
        }
      }
    }
    return mappedGroup;
  }
  React.useEffect(() => {
    const filterList = allEventTemplates
      .filter((et) => includeBarnTasks || !et.tags.find((t) => t.id === selectedBarn.barnMetadata.barnTaskTypeTagId))
      .filter((et) => includeHorseTasks || !et.tags.find((t) => t.id === selectedBarn.barnMetadata.horseTaskTypeTagId))
      .filter((et) => (tagsFilter.length <= 0 || tagsFilter.map((t) => t.id).every((v) => et.tags.map((t) => t.id).includes(v)))
        && (!debouncedSearch || (debouncedSearch.length > 0 && et.name.toLowerCase().indexOf(debouncedSearch) >= 0)))

    setGroupedTaskTemplates(groupTasksByTag(filterList.filter((et) => !et.tags.find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId))))
    setCalendarEvents(filterList.filter((et) => !!et.tags
      .find((t) => t.id === selectedBarn.barnMetadata.eventTaskTypeTagId)));
  }, [allEventTemplates, tagsFilter, includeBarnTasks, includeHorseTasks, debouncedSearch, groupByTags])

  const getSectionTitleForSuggestionGroup = (groupKey) => {
    if (groupKey === 'suggestDayTrend') return `Frequently Planned on ${getDayOfWeekFromNumber(selectedSlot.selectedSuggestion.dayOfWeek)}`;
    if (groupKey === 'suggestMonthlyTrend') return 'Most Commonly Planned Task';
    if (groupKey === 'suggestRecentTrend') return 'Frequently Planned Last 5 Days';
    return 'Unknown Suggestion Group'
  }

  const handleHideAllHorseSuggestions = () => {
    setOpenSuggestionHorseMenu(false);
    setOpenSuggestionHorseMenuAnchorEl(null);
    dispatch(updateHorseSuggestion(
      mappedHorseSuggestions[selectedSlot.selectedSuggestion.barnHorse.pingumTagId].suggestionId,
      { hideAllSuggestions: true },
    )).then(() => {
      setAlertMessage('Success, you will no longer see suggestions for this horse.')
    })
  }

  const handleHideTaskSuggestionForHorse = () => {
    const taskId = openSuggestionMenu;
    setOpenSuggestionMenu(false);
    setOpenSuggestionMenuAnchorEl(null);
    dispatch(updateHorseSuggestion(
      mappedHorseSuggestions[selectedSlot.selectedSuggestion.barnHorse.pingumTagId].suggestionId,
      {
        hiddenTaskSuggestions: [...(mappedHorseSuggestions[selectedSlot.selectedSuggestion.barnHorse.pingumTagId].hiddenTaskSuggestions || []),
          taskId],
      },
    )).then(() => {
      setAlertMessage('Success, this task will be hidden from future suggestions.')
    })
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          overflowy: 'auto',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Grid
          container
          spacing={2}
        >

          {
            includeCalendarEvents
              ? (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: tab === 2
                        ? 'none'
                        : 'flex',
                      gap: 2,
                      alignItems: 'center',
                      px: 2,
                    }}
                  >
                    <TextField
                      size="small"
                      onChange={(e) => { setSearch(e.target.value.toLocaleLowerCase()); }}
                      placeholder="Search..."
                      autoFocus
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                    />
                    <FormControl size="small">
                      <FormControlLabel
                        control={(
                          <Switch
                            size="small"
                            checked={groupByTags}
                            onChange={(e) => {
                              setGroupByTags(e.target.checked);
                              if (e.target.checked) {
                                global.window.localStorage.setItem('global_task_tag_grouping', e.target.checked);
                              } else {
                                global.window.localStorage.removeItem('global_task_tag_grouping');
                              }
                            }}
                          />
                        )}
                        label="Group by Tags"
                      />
                    </FormControl>
                  </Box>
                  <Box
                    sx={{
                      borderBottom: 1,
                      borderColor: 'divider',
                      margin: 'auto',
                    }}
                  >
                    <Tabs value={tab} onChange={(e, t) => setTab(t)} aria-label="menu tabs">
                      <Tab iconPosition="start" label="Tasks" {...a11yProps(0)} icon={<Task />} />
                      <Tab iconPosition="start" label="Calendars" icon={<CalendarToday />} {...a11yProps(1)} />
                    </Tabs>
                  </Box>
                </Grid>
              )
              : <Grid item xs={12}><Box /></Grid>
          }

        </Grid>
        {tab === 0 && (
          <Box sx={{ flex: 1 }}>
            <div
              role="tabpanel"
              hidden={tab !== 0}
              id={`tasks-tabpanel-${0}`}
              aria-labelledby={`tasks-tabpanel-${0}`}
            >
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  '& ul': { padding: 0 },
                  mr: 2,
                }}
                subheader={<li />}
              >
                {
                  selectedSlot && selectedSlot.selectedSuggestion && !search
                  && groupedSuggestions && Object.keys(groupedSuggestions).length > 0 && Object.keys(groupedSuggestions)
                    .filter((groupKey) => groupedSuggestions[groupKey] && groupedSuggestions[groupKey].length > 0).map((groupKey) => (
                      <li key={`suggestion-group-${groupKey}`}>
                        <ul>
                          <ListSubheader
                            sx={{
                              my: 1,
                              lineHeight: '28px',
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <AutoAwesome sx={{ color: '#FF6600 !important' }} />
                            <Box
                              sx={{ ml: 0.5 }}
                            >{getSectionTitleForSuggestionGroup(groupKey)}
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                ml: 2,
                              }}
                            >
                              <Horse horse={selectedSlot.selectedSuggestion.barnHorse.horse} chip />
                              {
                                isFetchingHorseSuggestion
                                  ? (
                                    <CircularProgress />
                                  )
                                  : (
                                    <IconButton
                                      onClick={(e) => {
                                        setOpenSuggestionHorseMenu(true);
                                        setOpenSuggestionHorseMenuAnchorEl(e.currentTarget);
                                      }}
                                    ><MoreVert />
                                    </IconButton>
                                  )
                              }

                            </Box>
                          </ListSubheader>
                          {
                            groupedSuggestions[groupKey].map((et) => (
                              <Box
                                key={`menu_event_template_${et.id}`}
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'flex-start',
                                }}
                              >
                                <TaskOptionComponent
                                  eventTemplate={et}
                                  onSelectTask={onTaskSelect}
                                  onSelectCalendarEvent={onCalendarEventSelect}
                                />
                                <IconButton sx={{ pt: '6px' }} onClick={(e) => { setOpenSuggestionMenu(et.id); setOpenSuggestionMenuAnchorEl(e.currentTarget); }}><MoreVert /></IconButton>
                              </Box>
                            ))
                          }

                          {
                            alertMessage && (
                              <Alert severity="success" onClose={() => setAlertMessage(null)}>
                                {alertMessage}
                              </Alert>
                            )
                          }
                        </ul>
                        <Divider sx={{ mt: 1 }} />
                      </li>
                    ))
                }
                {
                  mostUsed && mostUsed.length > 0 && !search && (
                    <li>
                      <ul>
                        <ListSubheader
                          sx={{
                            my: 1,
                            lineHeight: '28px',
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Star color="primary" />
                          <Box
                            sx={{ ml: 0.5 }}
                          >Frequently Used @ {selectedLocation.name}
                          </Box>
                        </ListSubheader>
                        {mostUsed.sort((a, b) => a.name.localeCompare(b.name)).map((et) => (<TaskOptionComponent key={`most_used_${et.id}`} eventTemplate={et} onSelectTask={onTaskSelect} onSelectCalendarEvent={onCalendarEventSelect} />))}
                      </ul>
                      <Divider sx={{ mt: 1 }} />
                    </li>
                  )
                }

                {
                  Object.keys(groupedTaskTemplates)
                    .sort((a, b) => {
                      if (!groupByTags) {
                        return parseInt(b, 10) === selectedBarn.barnMetadata.horseTaskTypeTagId
                          ? 0
                          : -1;
                      }
                      if (parseInt(b, 10) !== selectedBarn.barnMetadata.horseTaskTypeTagId
                        && parseInt(b, 10) !== selectedBarn.barnMetadata.barnTaskTypeTagId) {
                        return -(groupedTaskTemplates[b][0].tags.find((t) => t.id === parseInt(b, 10)) || { name: 'Unknown' }).name.localeCompare((groupedTaskTemplates[a][0].tags.find((t) => t.id === parseInt(a, 10)) || { name: 'Unknown' }).name)
                      }
                      return -1
                    })
                    .map((key) => {
                      const tag = groupedTaskTemplates[key][0].tags.find((t) => t.id === parseInt(key, 10)) || {
                        name: 'Unknown',
                        tagType: { name: 'Unknown' },
                      };
                      return (
                        <li key={`section-${key}`}>
                          <ul>
                            <ListSubheader
                              sx={{
                                my: 1,
                                lineHeight: '28px',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {tag.id === selectedBarn.barnMetadata.horseTaskTypeTagId && (<HorseIcon />)}
                              {tag.id === selectedBarn.barnMetadata.barnTaskTypeTagId && (<BarnIcon />)}
                              {(tag.id !== selectedBarn.barnMetadata.barnTaskTypeTagId
                                && tag.id !== selectedBarn.barnMetadata.horseTaskTypeTagId) && (
                                  <Icon
                                    style={{
                                      color: getColorForItem(tagTypes, tag.tagType.id),
                                      fontSize: '18px',
                                    }}
                                  >
                                    {getIconForItem(tagTypes, tag.tagType.id)}
                                  </Icon>
                                )}
                              <Box
                                sx={{ ml: 0.5 }}
                              >{tag.name}
                              </Box>
                            </ListSubheader>
                            {
                              groupedTaskTemplates[key].sort((a, b) => a.name.localeCompare(b.name)).map((et) => <TaskOptionComponent key={`menu_event_template_${et.id}`} eventTemplate={et} onSelectTask={onTaskSelect} onSelectCalendarEvent={onCalendarEventSelect} />)
                            }
                          </ul>
                        </li>
                      )
                    })
                }
              </List>
            </div>
          </Box>
        )}

        {tab === 1 && (
          <Box sx={{ flex: 1 }}>
            <div
              role="tabpanel"
              hidden={tab !== 1}
              id={`tasks-tabpanel-${1}`}
              aria-labelledby={`tasks-tabpanel-${1}`}
            >
              <List
                sx={{
                  width: '100%',
                  bgcolor: 'background.paper',
                  position: 'relative',
                  overflow: 'auto',
                  maxHeight: 600,
                  '& ul': { padding: 0 },
                }}
                subheader={<li />}
              >
                {
                  calendarEvents.sort((a, b) => a.name.localeCompare(b.name)).map((et) => (
                    <ListItemButton
                      key={`menu-event-template-option-${et.id}`}
                      dense
                      onClick={() => { onCalendarEventSelect(et) }}
                      sx={{
                        border: `1px solid ${blueGrey[100]}`,
                        borderRadius: 2,
                        mt: 1.5,
                        mx: 2,
                      }}
                    >
                      <ListItemAvatar>
                        <Avatar sx={{ backgroundColor: blueGrey[50] }}>
                          <Event sx={{ color: (et.eventDataDefaultValues && et.eventDataDefaultValues.calendarDisplayColor) || primary[500] }} />
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={et.name}
                        secondaryTypographyProps={{ comoponent: 'div' }}
                      />
                    </ListItemButton>
                  ))
                }
              </List>
            </div>
          </Box>
        )}
        <Menu
          anchorEl={openSuggestionHorseMenuAnchorEl}
          id="account-menu"
          open={openSuggestionHorseMenu}
          onClose={() => {
            setOpenSuggestionHorseMenu(false);
            setOpenSuggestionHorseMenuAnchorEl(null);
          }}
          // onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
        >
          <MenuItem
            onClick={() => { handleHideAllHorseSuggestions() }}
          >
            <VisibilityOff sx={{ mr: 2 }} color="secondary" /> Hide all suggestions for this horse
          </MenuItem>
        </Menu>
        <Menu
          anchorEl={openSuggestionMenuAnchorEl}
          id="account-menu"
          open={!!openSuggestionMenu}
          onClose={() => { setOpenSuggestionMenu(false); setOpenSuggestionMenuAnchorEl(null); }}
          // onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
        >
          <MenuItem
            onClick={() => {
              handleHideTaskSuggestionForHorse()
            }}
          >
            <VisibilityOff sx={{ mr: 2 }} color="secondary" /> Hide this task type from suggestions for this horse
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  )
}

SelectEventTemplate.propTypes = {
  tagsFilter: PropTypes.array,
  open: PropTypes.bool,
  includeBarnTasks: PropTypes.bool,
  includeHorseTasks: PropTypes.bool,
  includeCalendarEvents: PropTypes.bool,
  onTaskSelect: PropTypes.func,
  onCalendarEventSelect: PropTypes.func,
  setOpenAddCalendarEventModal: PropTypes.func.isRequired,
  setOpenAddTaskModal: PropTypes.func.isRequired,
  selectedSlot: PropTypes.object,
  tab: PropTypes.number,
  setTab: PropTypes.func,
};

SelectEventTemplate.defaultProps = {
  tagsFilter: [],
  open: false,
  includeBarnTasks: true,
  includeHorseTasks: false,
  includeCalendarEvents: true,
  onTaskSelect: () => { },
  onCalendarEventSelect: () => { },
  selectedSlot: null,
  tab: 0,
  setTab: () => { },
};

export default SelectEventTemplate;
